import React from 'react';

import PreviewExercise from './PreviewExercise';
import PreviewProgram from './PreviewProgram';
import Session from '../../../calendar/components/Session';
import Console from '../../../../lib/debug';

export default class Preview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            top: 0
        };
    }
    componentDidMount() {
        setTimeout(() => {
            this.setState(() => ({
                top: this.props.position ? this.calculateBounderies() : 0,
                itemId: this.props.item.id
            }));
        }, 300);
    }
    componentDidUpdate() {
        //todo: refactor this without setState?
        // let { item, position } = this.props;
        // let isOutside = this.isOutside();
        // if (isOutside && item.id !== this.state.itemId) {
        //     this.setState(() => ({
        //         top: this.calculateBounderies(),
        //         itemId: item.id
        //     }));
        // } else if (!isOutside && item.id !== this.state.itemId) {
        //     this.setState(() => ({
        //         top: position.top,
        //         itemId: item.id
        //     }));
        // }
    }
    calculateBounderies() {
        let previewValues = this.$preview.getBoundingClientRect();
        let windowHeight = window.innerHeight;
        let isOutside = this.isOutside();
        if (isOutside) {
            return windowHeight - previewValues.height;
        } else {
            return this.props.position.top;
        }
    }
    handleEdit() {
        this.props.onEdit && this.props.onEdit();
    }
    isOutside() {
        let previewValues = this.$preview.getBoundingClientRect();
        let windowHeight = window.innerHeight;
        return this.props.position.top + previewValues.height > windowHeight;
    }
    render() {
        Console.render('designer.Preview');
        const COMPENSATION = 10;
        let { item, type, fromDrawer } = this.props;
        let disableEdit = this.props.disableEdit;
        let previewItem = null;
        if (type === 'exercise') {
            previewItem = (
                <PreviewExercise
                    exercise={item}
                    exerciseRef={this.props.exerciseRef}
                    onEdit={this.handleEdit.bind(this)}
                    disableEdit={disableEdit}
                />
            );
        } else if (type === 'calendar' || type === 'program') {
            previewItem = <PreviewProgram program={item} />;
        } else if (type === 'session' && fromDrawer) {
            previewItem = (
                <Session
                    key={item.id}
                    session={item}
                    isPubEnabled={false}
                    isPreview={true}
                    programType={0}
                    fromDrawer={true}
                />
            );
        }
        let style = {};
        if (this.props.position) {
            style = {
                top: (this.state.top || this.props.position.top) - COMPENSATION,
                left: this.props.position.left - this.props.width - COMPENSATION
            };
        }
        if (this.props.width) {
            style['width'] = this.props.width;
        }
        return (
            <div
                className="Preview"
                ref={el => (this.$preview = el)}
                style={style}
                onMouseLeave={this.props.onLeave}
                onMouseEnter={this.props.onEnter}
            >
                {previewItem}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/view/designer/components/Preview/Preview.jsx